let timerId: any;
function debounce(callback: () => void, wait: number) {
  return () => {
    if (timerId) {

    } else {
      timerId = setTimeout(() => {
        callback();
        clearTimeout(timerId);
        timerId = undefined;
      }, wait);
    }
  };
}

export { debounce };
